import {createContext} from "preact";

export const EFFECTS = {
    TYPING_ANIMATION: 1, ANOTHER_EFFECT: 2, SPEAK: 100
};

const RENDERING_EFFECTS = [EFFECTS.TYPING_ANIMATION];

export class EffectsContextImpl {

    private effectsEnabled: any = [];

    public enableEffect(effectType: number, config?: any): any {
        this.effectsEnabled.push({type: effectType, config: config ? config : {}});
    }

    public disableEffect(effectType: number) {
        for (let i=0; i < this.effectsEnabled.length; i++) {
            if (this.effectsEnabled[i].type === effectType) {
                this.effectsEnabled.splice(i, 1);
                return;
            }
        }
    }

    public getEnabledEffects(): any {
        return this.effectsEnabled;
    }

    willHandleRendering(): boolean {
        for (const fx of this.effectsEnabled) {
            if (RENDERING_EFFECTS.indexOf(fx.type) >= 0) {
                return true;
            }
        }
        return false;
    }
}

export const EffectsContext = createContext<EffectsContextImpl>(new EffectsContextImpl());
